export function getLargestImageUrl(asset) {
    return asset?.attributes?.formats?.large?.url
        ?? asset?.attributes?.formats?.medium?.url
        ?? asset?.attributes?.url
}